<!--订单/详情页 订单数据表-->
<template>
    <div class="table">
        <v-data-table
            fixed-header
            :headers="headers"
            :items="order"
            :loading="loading"
            loading-text="数据加载中..."
            disable-sort
            :server-items-length="totalCount"
            :options.sync="options"
            :footer-props="footerProps"
            no-data-text="未查询到数据"
            :dark="theme.tableDark"
        >
            <template v-slot:item.total_power="{ item }">
                <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.total_power.toString()"
                    placement="top"
                >
                    <div
                        class="textOver"
                        :style="{ width: '2.3rem', color: powerColor(item.total_power) }"
                    >
                        {{ item.total_power }}
                    </div>
                </el-tooltip>
            </template>
            <!-- <template v-slot:item.createtime="{ item }">
                <el-tooltip
                    class="item"
                    effect="dark"
                    :content="formatDate(item.createtime * 1000)"
                    placement="top"
                >
                    <div class="textOver" style="width:5.9em">
                        {{ formatDate(item.createtime * 1000) }}
                    </div>
                </el-tooltip>
            </template> -->
            <template v-slot:item.updatetime="{ item }">
                <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                        开始时间：
                        {{ formatDate(item.createtime * 1000) }}
                        <br />
                        <i v-text="item.status == 3 ? '结束时间：' : '更新时间：'"></i>
                        {{ formatDate(item.updatetime * 1000) }}
                    </div>
                    <div class="textOver" style="width:7rem">
                        {{ formatDate(item.createtime * 1000) }}
                    </div>
                </el-tooltip>
            </template>
            <!-- <template v-slot:item.duration="{ item }">
                <el-tooltip class="item" effect="dark" :content="TimeSpan(item)" placement="top">
                    <div class="textOver" style="width: 3em">
                        {{ TimeSpan(item) }}
                    </div>
                </el-tooltip>
            </template> -->
            <template v-slot:item.elec_money="{ item }">
                <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                        电费： {{ String(item.elec_money) }}
                        <br />
                        服务费： {{ String(item.sevice_money) }}
                        <br />
                        总计：{{ addNum(item.elec_money, item.sevice_money) }}
                    </div>
                    <div class="textOver" style="width:3rem">
                        {{ addNum(item.elec_money, item.sevice_money) }}
                    </div>
                </el-tooltip>
            </template>
            <template v-slot:item.avatar="{ item }">
                <v-avatar size="40" v-if="item.avatar">
                    <img :src="'http://www.meisenpay.com/' + item.avatar" />
                </v-avatar>
            </template>
            <template v-slot:item.station_name="{ item }">
                <el-link :underline="false" @click="clickStation(item.station_id)">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.station_name"
                        placement="top"
                    >
                        <div class="textOver">
                            <v-img
                                width="1.2em"
                                contain
                                height="1.2em"
                                v-if="item.cec_id"
                                style="float: right"
                                src="../../assets/cec.svg"
                            ></v-img>
                            {{ setStationName(item.station_name) }}
                        </div>
                    </el-tooltip>
                </el-link>
            </template>
            <template v-slot:item.mobile="{ item }">
                <el-link :underline="false" @click="clickTel(item.mobile)">
                    {{ item.mobile }}
                </el-link>
            </template>
            <template v-slot:item.no="{ item }">
                <el-link type="primary" @click="toDetails(item)" icon="el-icon-view el-icon--right">
                    <el-tooltip class="item" effect="dark" :content="item.no" placement="top">
                        <div class="textOver" style="width: 6em">
                            {{ item.no }}
                        </div>
                    </el-tooltip>
                </el-link>
            </template>
            <template v-slot:item.connector_id="{ item }">
                <el-tooltip class="item" effect="dark" :content="item.connector_id" placement="top">
                    <el-link :underline="false" @click="clickConn(item.connector_id)">
                        <div class="textOver" style="width: 6em">
                            {{ item.connector_id }}
                        </div>
                    </el-link>
                </el-tooltip>
            </template>
            <template v-slot:item.soc="{ item }">
                <div class="textOver2">
                    <span>
                        {{ item.start_soc }}
                    </span>
                    <span v-if="item.start_soc">~</span>
                    <span>
                        {{ item.end_soc }}
                    </span>
                </div>
            </template>
            <template v-slot:item.status="{ item }">
                <el-tooltip
                    class="item"
                    effect="dark"
                    :content="statusText(item.status)"
                    placement="top"
                >
                    <div
                        class="textOver flex"
                        :style="{ width: '4.3rem', color: statusColor(item.status) }"
                    >
                        {{ statusText(item.status) }}
                    </div>
                </el-tooltip>
            </template>
            <template v-slot:item.toGun="{ item }">
                <el-button
                    v-if="item.status == 1"
                    size="mini"
                    type="primary"
                    circle
                    icon="iconfont icon-chongdianqiang1"
                    @click.stop="toGun(item)"
                ></el-button>
            </template>
            <template v-slot:item.cec="{ item }">
                <div v-if="item.cec_id && role === 0" class="textOver">
                    <el-tag size="mini">
                        {{ cecText(item.cec_id) }}
                    </el-tag>
                </div>
            </template>
            <template v-slot:item.stop="{ item }">
                <div v-if="isStop(item.createtime, item.updatetime, item.status)">
                    <el-button
                        type="danger"
                        icon="el-icon-switch-button"
                        circle
                        size="mini"
                        @click="stopOrder(item.no)"
                    ></el-button>
                </div>
            </template>
        </v-data-table>
        <div class="sum">
            <div
                v-for="(item, index) in orderSum"
                :key="index"
                class="sum-nav"
                :style="{ backgroundColor: theme.titleBgColor, color: theme.titleFontColor }"
            >
                <div class="sum-title center">{{ item.name }}</div>
                <div class="sum-nums">
                    <div class="sum-num center">{{ item.num }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
import Public from "@/public";
export default {
    data() {
        return {
            headers: [
                { text: "头像", value: "avatar" },
                { text: "手机", value: "mobile" },
                { text: "订单号", value: "no" },
                { text: "站点", value: "station_name" },
                { text: "充电枪", value: "connector_id" },
                { text: "电量(度)", value: "total_power" },
                { text: "SOC(%)", value: "soc" },
                // { text: "开始时间", value: "createtime" },
                { text: "时间", value: "updatetime" },
                // { text: "充电时长", value: "duration" },
                { text: "费用(元)", value: "elec_money" },
                { text: "互联互通", value: "cec" },
                { text: "", value: "status" },
                { text: "", value: "toGun" },
                { text: "", value: "stop" },
            ],
            order: [],
            totalCount: 1000,
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            options: {}, //外部控制分页
            loading: false,
            searchConditions: {}, //搜索条件
            orderSum: [
                {
                    type: "elec_money",
                    name: "电费",
                    num: 0,
                },
                {
                    type: "sevice_money",
                    name: "服务费",
                    num: 0,
                },
                {
                    type: "total_power",
                    name: "电量",
                    num: 0,
                },
            ],
        };
    },
    props: {
        searchData: Object,
    },
    watch: {
        // 刷新参数
        options: {
            handler(val) {
                let arr = [];
                let postData = {};
                Object.keys(this.searchConditions).forEach(key => {
                    if (this.searchConditions[key] == null) {
                        delete this.searchConditions.key;
                    } else {
                        arr.push(this.searchConditions.key);
                    }
                });
                if (arr.length == 0) {
                    this.refresh();
                } else {
                    Object.keys(this.searchConditions).forEach(key => {
                        postData[key] = this.searchConditions[key];
                    });
                    const { page, itemsPerPage } = this.options;
                    postData.from = (page - 1) * itemsPerPage;
                    postData.limit = itemsPerPage;
                    this.getData(postData);
                }
            },
            deep: true,
        },
        loading: {
            handler(val) {
                this.$emit("loading", val);
            },
        },
        searchData: {
            handler(val) {
                let postData = this.JsonData(val);
                this.searchConditions = this.JsonData(val);
                this.options.page = 1;
                const { page, itemsPerPage } = this.options;
                postData.from = (page - 1) * itemsPerPage;
                postData.limit = itemsPerPage;
                this.getData(postData);
            },
            deep: true,
        },
    },
    computed: {
        ...mapState([
            "orderInfos",
            "theme",
            "contactInfo",
            "connectorInfo",
            "orderData",
            "orderQuerySum",
			"user",
			"role"
        ]),
    },
    methods: {
		setStationName(station_name) {
			return Public.setStationName(this.user,station_name)
		},
        /*充电中状态订单前往充电枪页面*/
        async toGun(item) {
            await this.getConnectorInfo(item.station_id);
            if (!this.connectorInfo) {
                return;
            }
            let equipment_id = null;
            for (let i = 0; i < this.connectorInfo.length; i++) {
                if (item.connector_id == this.connectorInfo[i].connector_id) {
                    equipment_id = this.connectorInfo[i].equipment_id;
                }
            }
            if (!equipment_id) {
                util.ShowTip("未查找到充电桩信息，请刷新重试", 3);
                return;
            }
            console.log(equipment_id);

            this.$router.push({
                name: "ChargingGun",
            });
            store.commit("SET_ISJUMP", true);
            store.commit("SET_PILE_ID", equipment_id);
            store.commit("SET_GUN_SITE_ID", item.station_id);
        },
        /*获取某一个站点的充电桩信息*/
        async getConnectorInfo(station_id) {
            let postData = {
                station_id: station_id,
                from: 0,
                limit: 10000,
            };
            await store.dispatch("getConnector", postData);
        },
        /*手动结算订单*/
        stopOrder(no) {
            let params = {
                postData: {
                    no: no,
                },
                callback: () => {
                    this.refresh();
                },
            };
            store.dispatch("settlementOrder", params);
        },
        //判断是否出现停止按钮
        isStop(createtime, updatetime, status) {
            let now = new Date().getTime() / 1000;
            let time1 = updatetime - createtime;
            let time2 = now - updatetime;
            if (status != 3) {
                // if (time1 > 12 * 3600 || time2 > 12 * 3600) {
                if (time1 > 60 || time2 > 60) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        /*刷新*/
        async refresh() {
            let postData = null;
            let data = this.JsonData(this.searchData);
            if (data != {}) {
                postData = this.JsonData(this.searchData);
            }
            const { page, itemsPerPage } = this.options;
            postData.from = (page - 1) * itemsPerPage;
            postData.limit = itemsPerPage;
            await this.getData(postData);
        },
        /*获取订单数据*/
        async getData(postData) {
            let params = {
                postData,
                callback: () => {
                    this.loading = false;
                },
            };
            this.loading = true;
            if (!this.orderData || !!this.orderQuerySum) {
                await store.dispatch("getOrder", params);
                await store.dispatch("getOrderQuerySum", params);
            }
            this.totalCount = this.orderQuerySum["order_count"];

            this.orderSum[0].num = this.orderQuerySum["elec_money"]
                ? this.orderQuerySum["elec_money"].toFixed(2) + "￥"
                : 0;
            this.orderSum[1].num = this.orderQuerySum["sevice_money"]
                ? this.orderQuerySum["sevice_money"].toFixed(2) + "￥"
                : 0;
            this.orderSum[2].num = this.orderQuerySum["total_power"]
                ? this.orderQuerySum["total_power"].toFixed(2)
                : 0;
            this.order = this.orderInfos;
        },
        /*点击数据表中的电话号码*/
        clickTel(mobile) {
            this.$emit("clickTel", mobile);
        },
        /*点击数据表中的站点*/
        clickStation(station_id) {
            this.$emit("clickStation", station_id);
        },
        /*点击充电枪*/
        clickConn(ConnId) {
            this.$emit("clickConn", ConnId);
        },
        /*进入订单详情*/
        toDetails(item) {
            this.$router.push({
                name: "OrderDetails",
                params: { no: item.no },
            });
            store.commit("SET_ORDER_INFO", item);
        },
        /*充电时长时间格式*/
        TimeSpan(item) {
            if (item.updatetime == null) {
                return "";
            }
            let time = item.updatetime - item.createtime;
            var ret = "";
            let h; //时
            let m; //分
            let s; //秒
            if (time >= 3600) {
                h = parseInt(time / 3600);
                ret += h;
                ret += "小时";

                let remaining = time - h * 3600;
                if (remaining > 60) {
                    m = parseInt((time % 3600) / 60);
                    ret += m;
                    ret += "分钟";
                    s = remaining - m * 60;
                } else {
                    s = remaining;
                }
                ret += s;
                ret += "秒";
            } else if (time < 3600 && time >= 60) {
                m = parseInt((time % 3600) / 60);
                ret += m;
                ret += "分钟";
                s = time - m * 60;
                if (s > 0 && s < 60) {
                    ret += s;
                    ret += "秒";
                }
            } else if (time > 0 && time < 60) {
                s = time;
                ret += s;
                ret += "秒";
            } else {
                ret += "0";
            }
            return ret;
        },
        /*价格相加*/
        addNum(elec, sevice) {
            var r1, r2, m;
            try {
                r1 = elec.toString().split(".")[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = sevice.toString().split(".")[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            let a = Math.round(elec * m + sevice * m) / m;
            return a;
        },
        /*显示状态*/
        statusText(status) {
            let textArr = [
                {
                    id: 0,
                    value: "启动中",
                },
                {
                    id: 1,
                    value: "充电中",
                },
                {
                    id: 2,
                    value: "启动失败",
                },
                {
                    id: 3,
                    value: "完成",
                },
                {
                    id: 4,
                    value: "待支付",
                },
                {
                    id: 5,
                    value: "正在生成订单",
                },
            ];
            let text = "";
            textArr.forEach((val, index) => {
                if (val.id == status) {
                    text = val.value;
                }
            });
            return text;
        },
        /*状态文字颜色*/
        statusColor(status) {
            let textArr = [
                {
                    id: 0,
                    color: "#a5d8ff",
                },
                {
                    id: 1,
                    color: "#40a9ff",
                },
                {
                    id: 2,
                    color: "red",
                },
                {
                    id: 3,
                    color: "#212529",
                },
                {
                    id: 4,
                    color: "#0050b3",
                },
                {
                    id: 5,
                    color: "#002766",
                },
            ];
            let text = "";
            textArr.forEach((val, index) => {
                if (val.id == status) {
                    text = val.color;
                }
            });
            return text;
        },
        /*将时间转换为yyyy-mm-dd hh-mmm-ss*/
        formatDate(date) {
            var date = new Date(date);
            var YY = date.getFullYear() + "-";
            var MM =
                (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
                "-";
            var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hh = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
            var mm = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
            var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return YY + MM + DD + " " + hh + mm + ss;
        },
        /*功率颜色*/
        powerColor(power) {
            if (power >= 300) return "red";
            else return "black";
        },
        JsonData(data) {
            return JSON.parse(JSON.stringify(data));
        },
        /*互联互通文字*/
        cecText(cec_id) {
            if (this.contactInfo.length === 0) {
                store.dispatch("getConnact", {});
            }
            let text = "";
            if (!cec_id) {
                return;
            }
            for (let i = 0; i < this.contactInfo.length; i++) {
                if (cec_id === this.contactInfo[i].id) {
                    text = this.contactInfo[i].name;
                }
            }
            return text;
        },
    },
};
</script>
<style scoped>
.table {
    position: relative;
}
.sum {
    position: absolute;
    bottom: 0.5rem;
    left: 1rem;
    width: 28rem;
    height: 2rem;
    display: flex;
    flex-direction: row;
}
.sum-nav {
    width: 33%;
    height: 100%;
    border-radius: 0.6rem;
    display: flex;
    flex-direction: row;
    margin-left: 1%;
}
.sum-title {
    /* width: 30%; */
    padding: 0 0.5rem;
    height: 100%;
    font-size: 0.8rem;
}
.sum-nums {
    width: 60%;
    height: 100%;
    display: flex;
    align-items: center;
}
.sum-num {
    width: 100%;
    height: 60%;
    font-size: 0.8rem;
    border-left: 1px solid #bfbfbf;
}
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.textOver {
    width: 6rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.textOver2 {
    width: 3.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.flex {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
